"use client";

export { default } from "../src/app/error";
